import { T } from "../../util/t";
import { Typography } from "@mui/material";
import { Linkify } from "components/util/linkify";
import { string } from "yup";
import { createPropertyField } from "../../forms/propertyFields";
import { Field } from "../../forms/Field";
import { makeStyles } from "../../providers/makeStyles";

const useStyles = makeStyles(theme => ({
    card: {
        border: `2px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2, 2, 0, 2),
        marginBottom: theme.spacing(2)
    },
    notes: {
        width: "100%",
        wordBreak: "break-word",
        whiteSpace: "pre-line"
    }
}));
export const UserForm = ({ control, step: { registrationOptions, captureFields } }) => {
    const fields = [
        {
            name: "user_attributes.phone",
            type: "text",
            label: "Contact phone number",
            validation: string().required("We'll need your phone number for emergencies.").trim(),
        },
        ...(captureFields || [])
            .filter(p => p.level === "user")
            .map(property => createPropertyField(property, "user_attributes.properties", true)),
    ];
    const classes = useStyles();

    return (
        <>
            <Typography variant="h7" component="h2" marginBottom={2}><T>Your details</T></Typography>

            <section className={classes.card}>
                {fields.map(field => <Field key={field.name} field={field} control={control}/>)}
            </section>

            {registrationOptions?.notes &&
            <Typography className={classes.notes} component="p" marginBottom={2}><Linkify>{registrationOptions?.notes}</Linkify></Typography>}

            <Typography variant="body2" color="textSecondary" marginBottom={3}>
                <T registrationOptions={registrationOptions}>UserForm_agreement</T>
            </Typography>
        </>
    );
};
